import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { Button, TextBox } from 'wbm-inputs';
import { List } from './List';
import CloseIcon from '@material-ui/icons/Close';
import { Observable } from 'rxjs';
import { SuccessAlert } from '../SuccessAlert';

export interface ListInt {
    value: number | string,
    text: string
}

export interface ListButtonProps {
    list: Array<ListInt>,
    setValue: Function,
    value: any,
    className?: string,
    isValid?: boolean,
    invalidFeedback?: string,
    label: string,
    inputRequired?: boolean,
    inputString?: string,
    setLength?: number,
    changeZIndex?: Function,
    storedValue?: number,
    setStoredValue?: Function,
    setStoredLabelValue?: Function,
    isSkuGroupSearch?: boolean,
    forceInput?: boolean,
    qtyOnBlur?: (qty: any) => Observable<any>,
    inputIdentifier: string,
    inputLabel: string,
}

export interface listVal {
    value: any,
    text: string
}

export const DropdownWithList = ({ ...props }: ListButtonProps) => {
    const [display, setDisplay] = useState<boolean>(false);
    const [inputDisplay, setInputDisplay] = useState<boolean>(false);
    const [inputVal, setInputVal] = useState<string>(props.isSkuGroupSearch || props.forceInput ? props.value : '');
    const [previousVal, setPreviousVal] = useState<string>(props.value);
    const [activeVal, setActiveVal] = useState<string>('');
    const [qtyUpdatePending, setQtyUpdatePending] = useState(false);
    const [qtyUpdateError, setQtyUpdateError] = useState(false);
    const [focused, setFocused] = useState(false);
    const buttonRef = useRef<any>(null);
    const inputRef = useRef<any>(null);

    let isIE11 = false;
     if (typeof window !== 'undefined') {
         isIE11 = !!(window as any).MSInputMethodContext && !!(document as any).documentMode;
     }
    const WrapperComponent = isIE11 ? 'div' : Button;

    if ((props.storedValue !== undefined) && props.storedValue.toString() !== activeVal) {
        setActiveVal(props.storedValue.toString());
    }

    const className = useMemo(() => {
        let className = "btn-outline-primary btn-dropdown-list-outline ";

        const focusDropdown = ' focus-dropdown-menu-input';
        if (props.className) {
            className += props.className;
        }
        if (!props.isValid) {
            className += ' is-invalid';
        }
        if (props.isSkuGroupSearch || props.forceInput) {
            className += 'btn-qty-input';
        }
        if (inputDisplay && focused) {
            className += focusDropdown;
        }
        return className;
    }, [focused]);

    useEffect(() => {
        if (props.inputRequired && props.inputString !== '' && props.list.filter((item: listVal) => item.value === props.inputString).length <= 0) {
            props.list.push({ value: props.inputString || 0, text: props.inputString || '' });
        }
    }, [props.inputRequired, props.inputString, props.list]);

    useEffect(() => {
        setActiveVal(props.value);
    }, [props.value]);

    function setValue(val: any, text: string) {
        setDisplay(false);

        if (props.changeZIndex !== undefined) {
            props.changeZIndex(false);
        }
        props.setValue && props.setValue(val, text)
        if (val === props.inputString) {
            setInputDisplay(true);
        }
    }

    function openMenu(event: React.MouseEvent<HTMLButtonElement>) {
        event.stopPropagation();
        if (inputDisplay) {
            setDisplay(false);

            if (props.changeZIndex !== undefined) {
                props.changeZIndex(false);
            }
        } else {
            if (props.changeZIndex !== undefined) {
                props.changeZIndex(!display);
            }
            setDisplay(!display);
        }
    }

    function handleChange(e: string) {
        const val = e.replace(/[^\d]/g, '');
        setActiveVal(val);
        setInputVal(val);
        props.setValue && props.setValue(val, val);
    }

    function handleBlur(e: string) {
        const val = e.replace(/[^\d]/g, '');
        const arrayCheck = props.list.filter((obj: listVal) => {
            return (obj.value === Number(val) || obj.value === val)
        })
        if (val === '' || val === '0') {
            setInputDisplay(false);
            setInputVal('');
            props.setValue && props.setValue(props.list[0].value, props.list[0].text);
        } else if (inputVal === '' && arrayCheck.length > 0) {
            setInputDisplay(false);
            setInputVal('');
            props.setValue && props.setValue(arrayCheck[0].value, arrayCheck[0].text);
        }

        if (val !== '0' && val !== '') {
            if (val != previousVal && props.qtyOnBlur) {
                setQtyUpdatePending(true);
                props.qtyOnBlur(val).subscribe(
                    (response: any) => {
                        setQtyUpdatePending(false);
                    },
                    (error: any) => {
                        setQtyUpdateError(true);
                        setQtyUpdatePending(false);
                    }
                )
            }
            setPreviousVal(val);
        }
        setFocused(false);
    }

    useEffect(() => {
        if (inputRef && inputDisplay === true) {
            inputRef.current.focus();
        }
    }, [inputDisplay]);

    useEffect(() => {
        if (props.isSkuGroupSearch || props.forceInput) {
            setInputVal(props.value);
        }
    }, [props.value]);

    return (
        <div className="dropdown-menu-overall">
            {!qtyUpdatePending &&
                <WrapperComponent id={"dropdownButton"} className={className} onClick={(event: React.MouseEvent<HTMLButtonElement>) => openMenu(event)} ref={buttonRef}>
                    {(inputDisplay || props.isSkuGroupSearch || props.forceInput) ?
                        <>
                            <TextBox inputRef={inputRef} id={`dropdown-menu-input-${props.inputIdentifier}`} type="text" className=" dropdown-menu-input" maxLength={props.setLength || 4} value={inputVal.toString()} onChange={handleChange} onFocus={() => setTimeout(() => { inputRef?.current?.select(); setFocused(true); }, 20)} onBlur={handleBlur} label={`dropdown-menu-input-${props.inputLabel}`} hiddenLabel={true} showPlaceHolder={false} inputMode="numeric" autoFocus={inputDisplay} />
                        </>
                        : <span className="dropdown-input-label"> {props.label} </span>}
                    {!inputDisplay && !props.isSkuGroupSearch && !props.forceInput ? <div className="chev-space">
                        {props.isValid && !display ?
                            <span
                                className="material-icons chev animate-arrow"
                                aria-label="keyboard_arrow_down"
                            >
                                keyboard_arrow_down
                            </span>
                            : props.isValid && display ?
                                <span
                                    id={"dropdownChevron"}
                                    className="material-icons chev animate-arrow selected"
                                    aria-label="keyboard_arrow_down"
                                >
                                    keyboard_arrow_down
                                </span>
                                : <CloseIcon />
                        }
                    </div> : null}
                </WrapperComponent>
            }
            {!props.isValid ? <div className="invalid-text">{props.invalidFeedback}</div> : null}
            {!props.isSkuGroupSearch && !props.forceInput && !qtyUpdatePending && <List list={props.list} setValue={(val: any, text: string) => { setValue(val, text); if (props.setStoredValue && props.setStoredLabelValue) { props.setStoredValue(val); props.setStoredLabelValue(text); } }}
                value={activeVal} display={display} setDisplay={setDisplay} />}
            {qtyUpdatePending &&
                <div className={`spinner-container ${props.isSkuGroupSearch || props.forceInput ? "btn-qty-input" : ""}`}><span className="spinner-border spinner-border-md m-1" role="status" aria-hidden="true" /></div>
            }
            {qtyUpdateError && <SuccessAlert
                timerLengthInMS={3500}
                danger
                dangerText="Please try again. If the problem persists, please call 1-888-WB-MASON."
                dangerAttentionText="An error has occurred!"
                onClickClose={setQtyUpdateError}
                attentionText={''} text={''}
            />}
        </div>
    );
}